import React from 'react';
import { HereMapColors } from '../../../styles/agistics-colors';
import { DeviceLocation, Driver } from '../../../types';
import { localDateTimeDisplay } from '../../../utils/date-time-utils';
import { HereMapMarker } from '../../here-maps/here-map-marker';
import { getDriverIcon } from './live-map-driver-icon';

export const DeviceLocationMarker = ({deviceLocation, driver, onClick}: {
    deviceLocation: DeviceLocation;
    driver: Driver | undefined;
    onClick: () => void;
}) => (
    <HereMapMarker
        icon={getDriverIcon(deviceLocation.heading || 0, deviceLocation.orderId ? HereMapColors.ACTIVE : HereMapColors.INACTIVE, driver?.name)}
        latitude={deviceLocation.latitude}
        longitude={deviceLocation.longitude}
        onClick={onClick}
    >
        <div className='route-tooltip-hover'>
            <div className='route-tooltip-timestamp'>{localDateTimeDisplay(deviceLocation.timestamp)}</div>
        </div>
    </HereMapMarker>
);
